import React from 'react';

export default function EuroSign({ iconClass }: { iconClass?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="M169.3 256C196.8 163.5 282.5 96 384 96h96v48h-96c-74.6 0-138.4 46.4-164 112h172v48H208.7c-.5 5.3-.7 10.6-.7 16s.2 10.7.7 16H392v48H220c25.6 65.6 89.4 112 164 112h96v48h-96c-101.5 0-187.2-67.5-214.7-160H112v-48h48.6c-.7-10.5-.7-21.5 0-32H112v-48z" />
    </svg>
  )
}
